import { ButtonSignal, ControllerButtonMessage } from "flavr-common";
import { busService } from "../../bus";
const BUTTON_HOLD_TIME = 1000;
const BUTTON_DOUBLE_CLICK_TIME = 250;
export var ButtonState;
(function (ButtonState) {
    ButtonState[ButtonState["RELEASED"] = 0] = "RELEASED";
    ButtonState[ButtonState["PRESSED"] = 1] = "PRESSED";
    ButtonState[ButtonState["HOLD"] = 2] = "HOLD";
})(ButtonState || (ButtonState = {}));
export class InputDevice {
    constructor(uid, _pendingMessages, enabled = true, maxClickDuration = BUTTON_HOLD_TIME, maxDoubleClickTime = BUTTON_DOUBLE_CLICK_TIME) {
        this.uid = uid;
        this._pendingMessages = _pendingMessages;
        this.enabled = enabled;
        this.maxClickDuration = maxClickDuration;
        this.maxDoubleClickTime = maxDoubleClickTime;
    }
    setEnabled(enabled) {
        const time = Date.now();
        if (this.enabled !== enabled) {
            if (enabled) {
                // the device is now enabled -> send press messages for all buttons that are already pressed
                this.enabled = enabled;
                this.forEachButton((button) => {
                    if (button.state !== ButtonState.RELEASED) {
                        this.onButtonInput(button, ButtonSignal.PRESSED, time);
                        button.state = ButtonState.PRESSED;
                    }
                    button.lastChangeTimeStamp = time;
                    button.doubleClick = false;
                });
            }
            else {
                // the device is nolonger enabled -> send release messages for all pressed buttons
                this.forEachButton((button) => {
                    if (button.state !== ButtonState.RELEASED) {
                        if (button.state === ButtonState.HOLD) {
                            this.onButtonInput(button, ButtonSignal.HOLD_RELEASED, time);
                        }
                        this.onButtonInput(button, ButtonSignal.RELEASED, time);
                    }
                });
                this.enabled = enabled;
            }
        }
    }
    isEnabled() {
        return this.enabled;
    }
    onButtonPress(button) {
        if (button.state !== ButtonState.RELEASED)
            return;
        const time = Date.now();
        this.onButtonInput(button, ButtonSignal.PRESSED, time);
        if (time - button.lastChangeTimeStamp > this.maxDoubleClickTime)
            button.doubleClick = false;
        button.state = ButtonState.PRESSED;
        button.lastChangeTimeStamp = time;
    }
    onButtonRelease(button) {
        if (button.state === ButtonState.RELEASED)
            return;
        const time = Date.now();
        if (button.state === ButtonState.PRESSED) {
            if (time - button.lastChangeTimeStamp > this.maxClickDuration) {
                this.onButtonHold(button);
            }
            else {
                const input = button.doubleClick ? ButtonSignal.DOUBLE_CLICK : ButtonSignal.CLICKED;
                this.onButtonInput(button, input, time);
                button.doubleClick = !button.doubleClick;
            }
        }
        if (button.state === ButtonState.HOLD) {
            this.onButtonInput(button, ButtonSignal.HOLD_RELEASED, time);
            button.doubleClick = false;
        }
        this.onButtonInput(button, ButtonSignal.RELEASED, time);
        button.state = ButtonState.RELEASED;
        button.lastChangeTimeStamp = time;
    }
    onButtonHold(button) {
        this.onButtonInput(button, ButtonSignal.HOLD, Date.now());
        button.state = ButtonState.HOLD;
    }
    updateButtonState(button) {
        if (button.state === ButtonState.PRESSED) {
            const time = Date.now();
            if (time - button.lastChangeTimeStamp > this.maxClickDuration) {
                this.onButtonHold(button);
            }
        }
    }
    onButtonTypeChanged(button, newType) {
        const time = Date.now();
        if (button.state !== ButtonState.RELEASED) {
            if (button.state === ButtonState.HOLD) {
                this.onButtonInput(button, ButtonSignal.HOLD_RELEASED, time);
            }
            this.onButtonInput(button, ButtonSignal.RELEASED, time);
        }
        button.type = newType;
        if (button.state !== ButtonState.RELEASED) {
            this.onButtonInput(button, ButtonSignal.PRESSED, time);
            if (button.state === ButtonState.HOLD) {
                this.onButtonInput(button, ButtonSignal.HOLD, time);
            }
        }
    }
    onButtonInput(button, input, time) {
        if (this.enabled && button.type !== undefined) {
            busService.connection("InputDevice").send(new ControllerButtonMessage(this.uid, button.type, input, time));
        }
    }
    /**
     * ControllerModule can call this each frame.
     */
    update() {
        this.forEachButton((button) => {
            this.updateButtonState(button);
        });
    }
}
